<template>
  <div class="container">
    <Script></Script>
  </div>
</template>

<script>
import Script from "../../components/RobotCenter/Script.vue";
export default {
  components: {
    Script,
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>